import { createStyles, Grid, makeStyles } from "@material-ui/core";
import AdminHeader from "./HeaderMenuComponent/AdminHeader";
import HomeHeader from "../Pages/Home/HomeHeaderMenu";
// import PartnerComponent from './HeaderMenuComponent/PartnerComponent';
import EmpComponent from "./HeaderMenuComponent/EmpComponent";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "sticky",
      left: 0,
      right: 0,
      zIndex: 1301,
      top: 0,
    },
  })
);
function AdminHome() {
  const classes = useStyles();
  const globaluserData = useSelector((state: any) => state.commonReducer);

  const role = globaluserData?.role;
  // let role = sessionStorage.getItem("role");
  return (
    <div className={classes.root}>
      {role === "employee" ? <HomeHeader /> : ""}
      {role === "admin" ? <AdminHeader /> : ""}
      {role === "partner" ? <HomeHeader /> : ""}
    </div>
  );
}

export default AdminHome;
